var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { merge } from 'lodash';
import { classNames } from 'libs/react';
import { useDebounce } from 'libs/react';
import { useMutation } from 'libs/react';
import { useState } from 'libs/react';
import { FormDelete } from '../FormDelete';
import { FormField } from '../FormField';
import { FormGroup } from '../FormGroup';
import { React } from 'libs/react';
import './RemovalForm.scss';
/**
 * @component RemovalForm
 * @since 1.0.0
 */
export function RemovalForm(props) {
    const { style, label, infos, input, message, content, mutation, onProcess } = Object.assign({ style: 'normal' }, props);
    const onSuccess = useDebounce(props.onSuccess);
    const onFailure = useDebounce(props.onFailure);
    const [processing, setProcessing] = useState(false);
    const [successful, setSuccessful] = useState(false);
    const [error, setError] = useState(null);
    const [mutate] = useMutation(mutation);
    /**
     * @function onAccept
     * @since 1.0.0
     * @hidden
     */
    function onAccept() {
        return __awaiter(this, void 0, void 0, function* () {
            setError(null);
            setProcessing(true);
            setSuccessful(false);
            let mutation;
            if (onProcess) {
                mutation = onProcess();
            }
            else {
                mutation = {
                    variables: {
                        input
                    }
                };
            }
            if (mutation.optimisticResponse) {
                mutation.optimisticResponse = merge(mutation.optimisticResponse, {
                    __typename: 'Mutation'
                });
            }
            try {
                const result = yield mutate(mutation);
                if (result == null) {
                    setProcessing(false);
                    setSuccessful(false);
                    return;
                }
                if (onSuccess) {
                    onSuccess(result.data);
                }
            }
            catch (error) {
                // TODO
                // GÉRER LES ERREURS ICI avec un alert automatique qui va chercher le premier message
                if (onFailure) {
                    onFailure(error);
                }
                setError(error);
                setProcessing(false);
                setSuccessful(false);
                return;
            }
            setProcessing(false);
            setSuccessful(true);
        });
    }
    /**
     * @function onCancel
     * @since 1.0.0
     * @hidden
     */
    function onCancel() {
        if (props.onCancel) {
            props.onCancel();
        }
    }
    const className = classNames('delete-form', 'delete-form--' + style, { 'delete-form--has-error': error }, { 'delete-form--is-processing': processing }, { 'delete-form--is-successful': successful }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(FormGroup, null,
            React.createElement(FormField, null,
                React.createElement(FormDelete, { label: label, infos: infos, message: message, content: content, onAccept: onAccept, onCancel: onCancel })))));
}
